<template>
    <v-list-item>
        <v-list-item-avatar color="primary lighten-2" class="white--text" size="30">
            <v-img v-if="value.profilePicture" :src="$eod.getImageUrl(value.profilePicture.key)"></v-img>
            <span v-else>{{ value.getInitials() }}</span>
        </v-list-item-avatar>
        <v-list-item-content>
            <v-list-item-title v-text="value.getFullName()"></v-list-item-title>
            <v-list-item-subtitle v-if="showRole">{{ $t(value.getRole().name) }}</v-list-item-subtitle>
            <v-list-item-subtitle>
                <v-chip-group>
                    <v-chip small
                        v-if="value.attributes && value.attributes.jobtitle && value.attributes.jobtitle[0]"><v-icon small
                            left>mdi-badge-account-horizontal-outline</v-icon>{{
                                value.attributes.jobtitle[0] }}</v-chip>
                    <v-chip small v-if="value.email" :href="'mailto:' + value.email"><v-icon small
                            left>mdi-email-outline</v-icon>{{ value.email }}</v-chip>
                    <v-chip small
                        v-if="value.attributes && value.attributes.extra_email && value.attributes.extra_email[0]"
                        :href="'mailto:' + value.attributes.extra_email[0]"><v-icon small
                            left>mdi-email-outline</v-icon>{{ value.attributes.extra_email[0] }}</v-chip>
                    <v-chip small
                        v-if="value.attributes && value.attributes.phone_number && value.attributes.phone_number[0]"
                        :href="'tel:' + value.attributes.phone_number[0]"><v-icon small left>mdi-phone</v-icon>{{
                            value.attributes.phone_number[0] }}</v-chip>
                    <v-chip small
                        v-if="value.attributes && value.attributes.extra_phone && value.attributes.extra_phone[0]"
                        :href="'tel:' + value.attributes.extra_phone[0]"><v-icon small left>mdi-phone</v-icon>{{
                            value.attributes.extra_phone[0] }}</v-chip>
                </v-chip-group>
            </v-list-item-subtitle>
        </v-list-item-content>
        <div v-if="!readonly" class="d-flex align-items-center">
            <slot name="actions" v-bind:user="value"></slot>
            <eod-column-actions :item="value" :valueText="getTitle" :deleteAction="deleteItem" :editAction="editItem"
                deleteIcon="mdi-link-off" deleteText="Ontkoppelen" :show-copy="false"></eod-column-actions>
        </div>
    </v-list-item>
</template>
<script>
    import eodColumnActions from './columns/eod-column-actions.vue';

export default {
    name: 'eod-contacts-list-item',
    props: {
        value: Object,
        readonly: {
            type: Boolean,
            default: false
        },
        showRole: {
            type: Boolean,
            default: false
        },
    },
    components: {
        eodColumnActions
    },
    methods: {
        getTitle(item) {
            return item.getFullName();
        },
        deleteItem()
        {
            this.$emit('delete', this.value);
        },
        editItem() {
            this.$emit('edit', this.value);
        }
    },
}
</script>